import { layoutStyles } from "@/themes/layoutStyles";

export const styles = {
  containerTop: {
    zIndex: 30,
    position: "absolute",
    top: "-153px",
    left: "-173px",
    paddingBottom: 4,
    boxSizing: "border-box",
    cursor: "pointer",
  },

  containerTopLeft: {
    zIndex: 30,
    position: "absolute",
    top: "-153px",
    left: "-334px",
    paddingBottom: 4, // Don't delete this css property, works to the close functionality
    boxSizing: "border-box",
  },

  containerTopRight: {
    zIndex: 30,
    position: "absolute",
    top: "-153px",
    left: "0px",
    paddingBottom: 4, // Don't delete this css property, works to the close functionality
    boxSizing: "border-box",
  },

  containerBottom: {
    zIndex: 30,
    position: "absolute",
    top: "0px",
    left: "-173px",
    paddingTop: 4, // Don't delete this css property, works to the close functionality
    boxSizing: "border-box",
  },

  containerBottomLeft: {
    zIndex: 30,
    position: "absolute",
    top: "0px",
    left: "-334px",
    paddingTop: 4, // Don't delete this css property, works to the close functionality
    boxSizing: "border-box",
  },

  containerBottomRight: {
    zIndex: 30,
    position: "absolute",
    top: "0px",
    left: "0px",
    paddingTop: 4, // Don't delete this css property, works to the close functionality
    boxSizing: "border-box",
  },

  paper: {
    width: "360px",
    p: 2,
    cursor: "pointer",
  },

  paperToTop: {
    width: "360px",
    p: 2,
    cursor: "pointer",
    bottom: 0,
    transformOrigin: "top",
    position: "absolute",
  },

  hideButtons: {
    display: "none",
  },

  closeButton: {
    position: "absolute",
    right: "4px",
    top: "4px",
  },

  image: {
    flex: 1,
    "& img": {
      width: "100%",
    },
  },

  textContainer: {
    flex: 4,
  },

  title: {
    ...layoutStyles.ellipsisOneLine,
  },

  textContainerAids: {
    mb: 0.5,
  },

  routeButton: {
    ...layoutStyles.routeButton,
  },
};
